mutation PurchaseOrderItemUpdate($input: PurchaseOrderItemUpdateInput!) {
  purchaseOrderItemUpdate(input: $input) {
    purchaseOrder {
      id
      _rowTimestamp
      supplierId
      purchaseOrderTypeId
      purchaseOrderDate
      currencyId
      _isDistributionUpdateAllowed
      _subjectToDiscount
      _subjectToTax
      departmentId
      businessUnitId
      reason
      _isRevisable
      description
      controlTotalAmount
      _isUpdatable
      _isDeletable
      _requiredApprovalDocuments
      notesByEntityId(orderBy: _CREATED_DATE_DESC) {
        nodes {
          id
          _createdByUserName
          _createdDate
          noteComment
          isShared
          _isUpdatable
          _rowTimestamp
          _isDeletable
        }
      }
      purchaseOrderItems(orderBy: _SORT_ITEM_NUMBER_ASC) {
        nodes {
          _rowTimestamp
          purchaseOrderItemType {
            calculationType
            layoutType
            abbreviation
            description
            id
          }

          purchaseOrderItemTypeId
          id
          expenditureType {
            id
          }
          unitOfMeasureItemId
          unitOfMeasureItem {
            abbreviation
            unitOfMeasureItem
            id
            _unitOfMeasureGroupId
          }
          _isUpdatable
          _isDeletable
          scheduledDeliveryDate
          additionalDepartmentId
          additionalBusinessUnitId
          deliveryTelephoneNumber
          deliveryStateRegionId
          deliveryPostalCode
          deliveryNotes
          deliveryMainContact
          deliveryMobileNumber
          deliveryEmailAddress
          deliveryCountryId
          deliveryCityName
          subjectToAmount
          deliveryAttention
          deliveryAlternateContact
          deliveryAddressLine2
          deliveryAddressId
          deliveryAddressLine1
          _isActive
          _isDeprecated
          _isModified
          _isPartialReturn
          itemWeeks
          itemWeekRate
          itemWeekAmount
          itemUnitPrice
          itemToDate
          itemRentalDates
          itemQuantity
          itemNumber
          itemMonths
          itemMonthRate
          itemMonthAmount
          itemFromDate
          itemExtendedAmount
          itemDays
          itemDayRate
          itemDayAmount
          isTaxable
          isDiscounted
          isPackingSlipAttachmentRequired
          isDeliveryTracked
          isDeliveryAddressProtected
          _extendedItemTotal
          expenditureTypeId
          displayPoItemUnitPrice
          displayPoItemAccount
          displayPoItemType
          displayPoItemDescription
          displayPoItemRentalTerm
          displayPoItemTotal
          displayPoItemQuantity
          displayPoItemUnitPrice
          description
          taxTypeId
          purchaseOrderItemDistributions {
            nodes {
              id
              _createdDate
              _isDeletable
              _isUpdatable
              _rowTimestamp
              accountReference
              referenceCode6
              referenceCode7
              allocationPercent
              distributionAmount
              productionIncentiveId
              projectReference
              setReference
              tax1099T4TypeId
              referenceCode1
              referenceCode2
              referenceCode3
              referenceCode4
              referenceCode5
            }
          }
        }
      }
    }
  }
}
